import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PathHelper from "../../utils/path-helper";
import { APP_NAVIGATION } from "../../utils/constants";
import { getFeaturedAssessments } from "../../utils/utility-functions";

export const CallToActionSection = ({
  currentLocale,
  t,
  getAssessmentConnect,
  getAssessmentAttemptByUserIdConnect,
  assessmentId,
  userId,
  bgColor,
}) => {
  const navigate = useNavigate();
  const quizPath = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD_B, currentLocale);
  const [assessments, setAssessments] = useState([]);
  const [assessmentAttemptData, setAssessmentAttemptData] = useState([]);
  const [availableAssessmentsInCategory, setAvailableAssessmentsInCategory] =
    useState([]);

  useEffect(() => {
    if (getAssessmentConnect) {
      getAssessmentConnect(currentLocale).then((response) => {
        setAssessments(response || []);
      });
    }
  }, [getAssessmentConnect, currentLocale]);

  useEffect(() => {
    if (getAssessmentAttemptByUserIdConnect && userId) {
      getAssessmentAttemptByUserIdConnect(userId).then((res) => {
        setAssessmentAttemptData(res || []);
      });
    }
  }, [getAssessmentAttemptByUserIdConnect, userId]);

  useEffect(() => {
    if (
      assessments.length > 0 &&
      assessmentAttemptData.length > 0 &&
      assessmentId
    ) {
      const featuredAssessments = getFeaturedAssessments(
        assessments,
        assessmentAttemptData,
        assessmentId,
        1
      );
      setAvailableAssessmentsInCategory(featuredAssessments || []);
    }
  }, [assessments, assessmentAttemptData, assessmentId]);
  const getGradient = (index) => {
    const gradients = [
      "from-blue-600 to-indigo-600",
      "from-purple-600 to-pink-600",
      "from-orange-600 to-yellow-600",
      "from-green-600 to-emerald-600",
    ];
    // return gradients[index % gradients.length];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  if (availableAssessmentsInCategory.length === 0) {
    return (
      <div className="block bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
        <div
          className={`bg-gradient-to-r ${bgColor} p-8 flex flex-col justify-center items-center gap-2`}
        >
          {/* Assessment Title */}
          <h3 className="text-xl font-bold text-white text-center">
            {t("report.common.retake_assessment_message")}
          </h3>

          {/* CTA Button */}
          <button
            className="bg-white text-indigo-600 px-6 py-2 rounded-full font-semibold hover:bg-indigo-100 transition-colors w-fit"
            onClick={() => {
              navigate(`${dashboardPath.next}?showAssessment=true`);
            }}
          >
            {t("welcomeModal.take_the_test")}
          </button>
        </div>
      </div>
    );
  }
  return (
    <section className="space-y-6">
      {availableAssessmentsInCategory?.map((item, index) => (
        <div
          key={item.id}
          className="block bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
        >
          <div
            className={`bg-gradient-to-r ${bgColor} p-8 flex flex-col justify-center items-center gap-2`}
          >
            {/* Assessment Title */}
            <h3 className="text-xl font-bold text-white text-center">
              {t("report.common.assessment_suggestion_text")} : {item.title}
            </h3>

            {/* CTA Button */}
            <button
              className="bg-white text-indigo-600 px-6 py-2 rounded-full font-semibold hover:bg-indigo-100 transition-colors w-fit"
              id={`cta-${item.assessmentType}`}
              onClick={() => {
                navigate(`${quizPath.next}?assessmentId=${item.id}&newt=true`);
              }}
            >
              {t("welcomeModal.take_the_test")}
            </button>
          </div>
        </div>
      ))}
    </section>
  );
};
